module.exports = __webpack_public_path__ + "img/257-sardinia.bb255e01.svg";